if (!window.EcoScentProductSlider) {
  window.EcoScentProductSlider = {
    sectionSelector: '.product-slider-section',

    getSwiperConstructor: function () {
      return (window.MinimogLibs && window.MinimogLibs.Swiper) || window.Swiper;
    },

    updateProgressBar: function (swiper, progressBar) {
      if (!progressBar) return;

      const slidesPerView = typeof swiper.slidesPerViewDynamic === 'function'
        ? swiper.slidesPerViewDynamic()
        : Math.round(swiper.params.slidesPerView);
      const totalSlides = swiper.slides.length;

      if (totalSlides <= slidesPerView || swiper.isEnd) {
        progressBar.style.width = '100%';
        return;
      }

      const filledPercent = ((swiper.activeIndex + slidesPerView) / totalSlides) * 100;
      progressBar.style.width = Math.min(filledPercent, 100) + '%';
    },

    positionArrows: function (section) {
      const track = section.querySelector('.product-slider-track-wrap');
      const image = section.querySelector('.product-slider-card-image-wrap');
      if (!track || !image) return;

      const trackTop = track.getBoundingClientRect().top;
      const imageRect = image.getBoundingClientRect();
      const imageCentre = imageRect.top - trackTop + imageRect.height / 2;

      track.style.setProperty('--product-slider-arrow-top', imageCentre + 'px');
    },

    createSlider: function (section) {
      const namespace = window.EcoScentProductSlider;
      const SwiperConstructor = namespace.getSwiperConstructor();
      const container = section.querySelector('[data-product-slider-swiper]');
      if (!SwiperConstructor || !container) return null;

      const progressBar = section.querySelector('[data-product-slider-progress-bar]');

      const slider = new SwiperConstructor(container, {
        slidesPerView: 2,
        spaceBetween: 16,
        loop: false,
        navigation: {
          prevEl: section.querySelector('[data-product-slider-previous]'),
          nextEl: section.querySelector('[data-product-slider-next]'),
        },
        on: {
          afterInit: function () {
            const swiper = this;
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                namespace.updateProgressBar(swiper, progressBar);
                namespace.positionArrows(section);
              });
            });
          },
          slideChange: function () {
            namespace.updateProgressBar(this, progressBar);
          },
          breakpoint: function () {
            const swiper = this;
            requestAnimationFrame(function () {
              namespace.updateProgressBar(swiper, progressBar);
              namespace.positionArrows(section);
            });
          },
        },
        breakpoints: {
          768: { slidesPerView: 3, spaceBetween: 20 },
          1024: { slidesPerView: 4, spaceBetween: 20 },
        },
      });

      namespace.updateProgressBar(slider, progressBar);
      namespace.positionArrows(section);

      window.addEventListener('resize', function () {
        namespace.positionArrows(section);
      });

      return slider;
    },

    ensureHoverImage: function (card, mainImage, hoverSource) {
      let hoverImage = card.querySelector('.card-hover__img--alt');
      if (hoverSource && !hoverImage) {
        hoverImage = mainImage.cloneNode(false);
        hoverImage.removeAttribute('data-product-slider-card-image');
        hoverImage.classList.add('card-hover__img--alt');
        hoverImage.alt = '';
        hoverImage.setAttribute('aria-hidden', 'true');
        mainImage.after(hoverImage);
      }
      return hoverImage;
    },

    selectSwatchVariant: function (card, swatch) {
      const namespace = window.EcoScentProductSlider;
      const mainImage = card.querySelector('[data-product-slider-card-image]');
      const variantImage = swatch.dataset.variantImg;
      const variantUrl = swatch.dataset.variantUrl;

      card.querySelectorAll('[data-product-slider-swatch]').forEach(function (otherSwatch) {
        otherSwatch.classList.remove('is-active');
      });
      swatch.classList.add('is-active');

      if (variantUrl) {
        card.querySelectorAll('[data-product-slider-card-link]').forEach(function (link) {
          link.href = variantUrl;
        });
      }

      if (!mainImage || !variantImage) return;

      mainImage.removeAttribute('srcset');
      mainImage.src = variantImage;
      if (swatch.dataset.variantImgAlt) mainImage.alt = swatch.dataset.variantImgAlt;

      const media = card.querySelector('[data-product-slider-card-media]');
      const hoverSource = swatch.dataset.variantHoverImg;
      const hoverImage = namespace.ensureHoverImage(card, mainImage, hoverSource);

      if (hoverSource && hoverImage) {
        hoverImage.removeAttribute('srcset');
        hoverImage.src = hoverSource;
      }
      if (media) media.classList.toggle('card-hover--picked', !hoverSource);
    },

    handleCardClick: function (event) {
      const swatch = event.target.closest('[data-product-slider-swatch]');
      if (!swatch) return;
      window.EcoScentProductSlider.selectSwatchVariant(event.currentTarget, swatch);
    },

    initSection: function (section) {
      const namespace = window.EcoScentProductSlider;
      if (section.dataset.productSliderReady === 'true') return;
      section.dataset.productSliderReady = 'true';

      namespace.createSlider(section);

      section.querySelectorAll('[data-product-slider-card]').forEach(function (card) {
        card.addEventListener('click', namespace.handleCardClick);
      });
    },

    initAllSections: function (root) {
      const namespace = window.EcoScentProductSlider;
      const scope = root || document;
      scope.querySelectorAll(namespace.sectionSelector).forEach(namespace.initSection);
    },

    handleSectionLoad: function (event) {
      window.EcoScentProductSlider.initAllSections(event.target);
    },

    listen: function () {
      const namespace = window.EcoScentProductSlider;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          namespace.initAllSections();
        });
      } else {
        namespace.initAllSections();
      }

      document.addEventListener('shopify:section:load', namespace.handleSectionLoad);
    },
  };

  window.EcoScentProductSlider.listen();
}
